export { default } from './useAnalytics'

export const AnalyticsEvents = {
    PageView: 'PAGE_VIEW',
    ListView: 'LIST_VIEW',
    ListViewClick: 'LIST_VIEW_CLICK',
    ContentView: 'CONTENT_VIEW',
    JobApplyNow: 'JOB_APPLY_NOW'
}